
import { Expose} from "class-transformer";

export class AvailabilityDTO {
  @Expose({ name: "analysis_type" })
  public analysisType !: string;
  
  @Expose({ name: "crop_type" })
  public cropType !: string;

  public years !: number[];

}